import type { CSS } from '../../stitches.config';
import type { SpacingScale } from './sizes';

export const spacingCSS = (spacing?: SpacingScale): CSS =>
  spacing != null
    ? {
        gap: `$${spacing}`,
      }
    : {};
